import type { Personnel } from '@/lib/types';
import { formatDateKey } from '@/lib/utils/holidays';

/**
 * 재직 판정 — **퇴사일 당일까지 재직**이다(사용자 결정 2026-09-30).
 *
 * 퇴사일은 마지막 근무일이고 인사팀은 미리 적는다. `!person.leaveDate` 로 가르면 적는 순간
 * 배치표·전술판·직원찾기에서 사라진다. 서버 매퍼의
 * `(leave_date IS NULL OR leave_date >= CURRENT_DATE)` 와 같은 문장이라, 화면과 서버가 같은 사람을 센다.
 *
 * `YYYY-MM-DD` 끼리의 문자열 비교라 시각대 문제가 없다.
 */
export function isWorking(person: Pick<Personnel, 'leaveDate'>, today: string = formatDateKey(new Date())): boolean {
  return !person.leaveDate || person.leaveDate >= today;
}
